import React, { createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
export const CartContext = createContext(0);

const Main = () => {
    const [cart, setCart] = useState([]);
    return (
        <div>
            <CartContext.Provider value={[cart, setCart]}>
            <Header></Header>
            <Outlet></Outlet>
            <Footer></Footer>
            </CartContext.Provider>
        </div>
    );
};

export default Main;